import { inject, Injectable, Injector } from '@angular/core';

import { DialogRef, DialogService } from '@hglobal/fin-ui';
import { BaseDialogComponent } from 'app/common/base-dialog/base-dialog.component';

import { DialogData } from '../entities';

@Injectable()
export class IwDialogService {
  readonly #dialogService = inject(DialogService);

  open<T, V>(props: DialogData<T, V>, injector?: Injector): DialogRef {
    return this.#dialogService.open(
      BaseDialogComponent,
      {
        ...props,
      },
      { parentInjector: injector },
    );
  }
}
